export class ChangeUserFormState {
  public static readonly type = '[FormStatus] Change form';

  constructor(public userIsBeingEdited: boolean) {}
}
